import { Environment, CameraControls, Html, PresentationControls, Float, Text } from '@react-three/drei'
import { EffectComposer, SMAA, SSAO } from '@react-three/postprocessing'
import { BlendFunction } from 'postprocessing'
import { useEffect, useRef } from 'react'
import useGame from './stores/useGame.jsx'
import * as THREE from'three'
import { Part } from './part.jsx'
import { useThree } from '@react-three/fiber'

const { DEG2RAD } = THREE.MathUtils

var audioTrigger = false

export default function Experience()
{
    const state = useThree()

    const phase = useGame((state) => state.phase)
    const touched = useGame((state) => state.touched)
    const zoom = useGame((state) => state.zoom)

    const p1 = useGame((state) => state.p1)
    const p2 = useGame((state) => state.p2)
    const p3 = useGame((state) => state.p3)
    const p4 = useGame((state) => state.p4)
    const p5 = useGame((state) => state.p5)
    const p6 = useGame((state) => state.p6)
    const p7 = useGame((state) => state.p7)

    const infoPanel = useGame((state) => state.infoPanel)

    const cameraControlsRef = useRef()

 
    useEffect(()=>
    {

        if(phase === 'standard' && state.size.width > state.size.height)
            {
                var position = new THREE.Vector3(2, 1, 2)
                var target = new THREE.Vector3(-0.5,0.15,0.5)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                cameraControlsRef.current.truckSpeed = 0
                cameraControlsRef.current.dollySpeed = 0
                cameraControlsRef.current.polarRotateSpeed = 0
                cameraControlsRef.current.azimuthRotateSpeed = 0

            }

        else
            {
                var position = new THREE.Vector3(3, 1, 3)
                var target = new THREE.Vector3(0,0.65,0.1)
                cameraControlsRef.current.setLookAt(...position, ...target, true)
                cameraControlsRef.current.truckSpeed = 0
                cameraControlsRef.current.dollySpeed = 0
                cameraControlsRef.current.polarRotateSpeed = 0
                cameraControlsRef.current.azimuthRotateSpeed = 0

            }

    },[phase, state.size.width])


        const Points = () =>
            {

            return  <>

                { infoPanel === 'null' &&  <>
                    <Html wrapperClass='point' position={new THREE.Vector3( -0.5, 0.5, 0 )}  > 
                        <div className="pulse" onClick={()=> { p1() } }></div>
                        <div className="dot" onClick={()=> { p1() } }></div> 
                    </Html>
                </>}

                </>
            }

     return <>
            <directionalLight 
                color={new THREE.Color( 'white' )}
                position={[-1, 1, -1]} 
                intensity={ 10 } 
                castShadow 
                shadow-mapSize={[512, 512]}
                shadow-camera-top={2}
                shadow-camera-bottom={-2}
                shadow-camera-left={-2}
                shadow-camera-right={2}
            />

            <CameraControls 
                ref={cameraControlsRef}
                smoothTime={1}
                makeDefault
                onStart={touched}
                

            />
            <PresentationControls
                enabled={true} // the controls can be disabled by setting this to false
                global={true} // Spin globally or by dragging the model
                cursor={false} // Whether to toggle cursor style on drag
                snap={true} // Snap-back to center (can also be a spring config)
                speed={1} // Speed factor
                zoom={1} // Zoom factor when half the polar-max is reached
                polar={[- Math.PI / 2, Math.PI / 2]} // Vertical limits
                azimuth={[-Infinity, Infinity]} // Horizontal limits
                config={{ mass: 1, tension: 170, friction: 26 }}
                >
                    <Float
                      speed={1} // Animation speed, defaults to 1
                      rotationIntensity={0} // XYZ rotation intensity, defaults to 1
                      floatIntensity={0.5} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
                      floatingRange={[-0.1, 0.1]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
                      >
                        
                        <Part scale={[0.1,0.1,0.1]}/>
                        <Points/>
                    </Float>
            </PresentationControls>

            <Environment 
                preset='studio'
                background={false} 
                environmentIntensity={1}    
                environmentRotation={[0,0,0]}  
                flipX ={true}                     
            />
        
    </>
}